
   import Vue from 'vue'
   import { Chip } from '@/components'

   export default Vue.extend({
      name: 'StatusComponent',
      props: {
         value: Boolean,
         params: Object as () => { [key: string]: StatusDefinition },
      },
      computed: {
         valueAsString(): string {
            if (this.value === null) {
               return 'null'
            } else {
               return this.value + ''
            }
         },

         definition(): StatusDefinition {
            return this.params[this.valueAsString]
         },

         text(): string {
            return this.definition ? this.definition.text : ''
         },
         type(): string {
            return this.definition ? this.definition.type : ''
         },

         icon(): string {
            return this.definition ? this.definition.icon : ''
         },
      },
      components: { Chip },
   })
